import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserData } from '@osapp/model';
import { ELogActionId } from '@osapp/modules/logger/models/ELogActionId';
import { LoggerService } from '@osapp/modules/logger/services/logger.service';
import { GroupsService } from '@osapp/services';
import { EIdlLogActionId } from 'apps/idl/src/modules/logger/models/EIdlLogActionId';
import { EUpdateMode } from 'apps/idl/src/modules/patients/model/eupdate-mode.enum';
import { IPatient } from 'apps/idl/src/modules/patients/model/IPatient';
import { IUpdateHistory } from 'apps/idl/src/modules/patients/model/iupdate-history';
import { PatientsService } from 'apps/idl/src/modules/patients/services/patients.service';
import { of } from 'rxjs';
import { concatMap, defaultIfEmpty, mergeMap, tap } from 'rxjs/operators';

@Component({
	templateUrl: './creation-patient.page.html',
	styleUrls: ['./creation-patient.page.scss'],
})
export class CreationPatientPage implements OnInit {
	
	public readonly logSourceId = "IDL.PAT.C::";
	public model: IPatient;
	public idPatient: string;
	public patientOrdonnance = false;

	constructor(
		private svcPatients: PatientsService,
		private router: Router,
		private svcLogger: LoggerService,
		private route: ActivatedRoute
	) { }
	ngOnInit(): void {
		this.patientOrdonnance = history.state.patientOrdonnance;
		this.idPatient = this.route.snapshot.paramMap.get('idPatient');
		if(this.idPatient){
			this.svcPatients.getPatient(this.idPatient).subscribe((patient: IPatient) => {
				this.model = patient;
			})
		}
	}

	public createPatient = (patient: IPatient) => {
		this.svcLogger.action(this.logSourceId, "Création du patient.", EIdlLogActionId.patientCreate as unknown as ELogActionId, { userId: UserData.current?._id, patientId: patient._id });
		
		of(this.svcPatients.initializePatient(patient)).pipe(
			concatMap(() => this.svcPatients.savePatientAnakin(patient)),
			concatMap(() => this.svcPatients.createPatientLinks(patient))
		).subscribe(() => {
			this.patientOrdonnance ?
				this.router.navigate(['ordonnances', 'add'], { state: { patientId: patient._id } })
				: this.router.navigate(["/patients", patient._id], { state: { tabSelected: "Informations" } });
		})
	}

	public editPatient = (patient: IPatient) => {

		this.model = patient;
		this.svcLogger.action(this.logSourceId, "Édition du patient.", EIdlLogActionId.patientUpdate as unknown as ELogActionId, { userId: UserData.current?._id, patientId: this.model._id });
		
		return of(this.model)
		.pipe(
			tap(() => {
				const loUpdateHistory: IUpdateHistory = {
					date: this.model.updateDate = new Date(),
					mode: this.model.updateMode = EUpdateMode.manual
				};
				this.model.updateHistory = [...this.model.updateHistory, loUpdateHistory];
			}),
			mergeMap(() => this.svcPatients.savePatientAnakin(this.model)),
			tap(_ => this.svcPatients.saveAdressCacheData(this.model)),
			defaultIfEmpty(true),
			
		).subscribe((success: boolean) => {
			if (success) {
				this.router.navigate(["patients", this.model._id], { state: { tabSelected: "Informations" } });
			}
		});
	}

}
